import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { createReactEditorJS } from "react-editor-js";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { addTour } from "../../actions/vrtour";

import Volume from "../layout/Employers/Volume";

import { evaluate } from "../../utilities/props";

import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import { EDITOR_JS_TOOLS } from "../EditorTools/Tools";

import EditorJSError from "../layout/IME/EditorJSError";

const CreateTour = ({
  auth: { user },
  isAuthenticated,
  vrtour: { vrtour },
  addTour,
  time,
  videoduration,
}) => {
  const [file, setFile] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [dataFile, setDataFile] = useState("");
  const [articleError, setShowArticleError] = useState({
    show: false,
    text: "",
  });
  time = evaluate(time);
  videoduration = evaluate(videoduration);
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showOverlay, setshowOverlay] = useState(true);
  const [tourTitle, setTourTitle] = useState("");
  const [tourImage, setTourImage] = useState("");

  const ReactEditorJS = createReactEditorJS();

  const editorJS = useRef(null);

  const handleInitialize = useCallback((instance) => {
    editorJS.current = instance;
  }, []);

  const handleSave = useCallback(async () => {
    const savedData = await editorJS.current.save();

    if (savedData.blocks.length > 0) {
      await addTour(savedData, dataFile, tourImage, tourTitle);
    } else {
      setShowArticleError({
        show: true,
        text: "Please enter text or images into the article body.",
      });
    }
  }, [dataFile, tourImage, tourTitle]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);

  if (vrtour && vrtour.msg === "VRTour Successfully Created") {
    return <Redirect to={`/${user.channelid}/content`} />;
  }

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.role === "innovator") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {articleError.show && (
        <EditorJSError
          user={user}
          setShowArticleError={setShowArticleError}
          articleError={articleError}
        />
      )}
      <LoggedInNavBlue />
      <form
        method="POST"
        className="flex-all-content-fixed"
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
        }}
      >
        <section className="main-body-article">
          {file !== "" && (
            <div>
              <div className="sub-section-container-tour">
                <div className="flex-only">
                  <p className="sub-section blue">*Tour Video</p>
                </div>
              </div>
              <div
                className="add-keyword-alt background-blue"
                onClick={() => {
                  setFile("");
                }}
              >
                <i className="fas fa-times fa-sm mx-5"></i>Remove Video
              </div>
            </div>
          )}
          <div className="create-article">
            {file === "" ? (
              <div className="create-article-container">
                <label htmlFor="tourVideo" className="setup-image-container">
                  <div className="create-image-icons blue">
                    <i className="fas fa-plus fa-lg blue"></i>
                    <i className="fas fa-street-view fa-4x mx-5 blue"></i>
                  </div>
                </label>
                <input
                  type="file"
                  name="tourVideo"
                  id="tourVideo"
                  className="file-upload blue"
                  onChange={(e) => {
                    setFile(URL.createObjectURL(e.target.files[0]));
                    setDataFile(e.target.files[0]);
                  }}
                />
              </div>
            ) : (
              <div className="create-article-container">
                <label htmlFor="tourVideo" className="setup-image-container">
                  <div className="article-media-container">
                    <div
                      className={
                        showOverlay
                          ? "alt-video-overlay"
                          : "alt-video-overlay-pause"
                      }
                    >
                      <div className="alt-left-controls">
                        <ul className="controls">
                          <Volume
                            className="Rac__volume"
                            onChange={(level) => {
                              const volume = level / 100;
                              videoRef.current.volume = volume;
                              videoRef.current.muted = volume === 0;
                            }}
                          />
                        </ul>
                      </div>
                    </div>
                    <video
                      ref={videoRef}
                      autoPlay={true}
                      className="article-media"
                      src={file}
                    />
                    <input
                      type="file"
                      name="tourVideo"
                      id="tourVideo"
                      className="file-upload"
                      onChange={(e) => {
                        setFile(URL.createObjectURL(e.target.files[0]));
                        setDataFile(e.target.files[0]);
                      }}
                    />
                  </div>
                </label>
              </div>
            )}
          </div>
          <div>
            <div className="sub-section-container-title">
              <div className="flex-only">
                <p className="sub-section blue">*Video Poster</p>
              </div>
            </div>
            {imageFile !== "" && (
              <div
                className="add-keyword-alt background-blue"
                onClick={() => {
                  setImageFile("");
                }}
              >
                <i className="fas fa-times fa-sm mx-5"></i>Remove Poster
              </div>
            )}
            <div className="create-article">
              {imageFile === "" ? (
                <div className="create-article-container">
                  <label
                    htmlFor="articleImage"
                    className="setup-image-container"
                  >
                    <div className="create-image-icons blue">
                      <i className="fas fa-plus fa-lg blue"></i>
                      <i className="fas fa-image fa-4x mx-5 blue"></i>
                    </div>
                  </label>
                  <input
                    type="file"
                    name="articleImage"
                    id="articleImage"
                    className="file-upload blue"
                    onChange={(e) => {
                      setImageFile(URL.createObjectURL(e.target.files[0]));
                      setTourImage(e.target.files[0]);
                    }}
                  />
                </div>
              ) : (
                <div className="create-article-container">
                  <label
                    htmlFor="articleImage"
                    className="setup-image-container"
                  >
                    <div className="article-media-container">
                      <img className="article-media" src={imageFile} />
                      <input
                        type="file"
                        name="articleImage"
                        id="articleImage"
                        className="file-upload"
                        onChange={(e) => {
                          setImageFile(URL.createObjectURL(e.target.files[0]));
                          setTourImage(e.target.files[0]);
                        }}
                      />
                    </div>
                  </label>
                </div>
              )}
            </div>
          </div>
          <div className="items-container-article">
            <div className="sub-section-container-alt">
              <div className="flex-only">
                <p className="sub-section blue bold">VR Tour Title</p>
              </div>
              <div className="input-label-container">
                <label htmlFor="tourtitle" className="labels-input blue bold">
                  *VR Tour Title:
                </label>
                <input
                  type="text"
                  name="tourtitle"
                  value={tourTitle}
                  className="input-item"
                  placeholder="Enter VR Tour title"
                  onChange={(e) => setTourTitle(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="items-container-article">
            <div>
              <div className="flex-only">
                <p className="sub-section-alt blue">Tour Description</p>
              </div>
              <div className="input-label-container-alt">
                <label htmlFor="articlebody" className="labels-input blue">
                  *Tour Description:
                </label>
              </div>
              <ReactEditorJS
                holder="custom"
                onInitialize={handleInitialize}
                tools={EDITOR_JS_TOOLS}
              >
                {" "}
                <div id="custom" className="edit-article white" />
              </ReactEditorJS>
            </div>
          </div>
        </section>
        {file !== "" &&
          tourTitle !== "" &&
          imageFile !== "" &&
          !articleError.show && (
            <div className="submit-changes">
              <button
                className="submit-changes-button background-blue"
                onClick={() =>
                  !articleError && addTour(file, tourImage, tourTitle)
                }
              >
                Create VR Tour
              </button>
            </div>
          )}
      </form>
    </Fragment>
  );
};

CreateTour.propTypes = {
  auth: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  addTour: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
  vrtour: state.vrtour,
});

export default connect(mapStateToProps, { addTour })(CreateTour);
